import styled from 'styled-components';
import { ASSETS } from '../../../../../../assets';

export const Icon = styled(ASSETS.NODES_CONNECTION)`
  width: 12px;
`;
